/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FileDownloadModel } from '../../models/file-download-model';
import { ResultsReportRequestModel } from '../../models/results-report-request-model';

export interface SessionResultsReportPost$Params {
  
    /**
     * The request model containing session ID and optional report configuration
     */
    body?: ResultsReportRequestModel
}

export function sessionResultsReportPost(http: HttpClient, rootUrl: string, params?: SessionResultsReportPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<FileDownloadModel>> {
  const rb = new RequestBuilder(rootUrl, sessionResultsReportPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<FileDownloadModel>;
    })
  );
}

sessionResultsReportPost.PATH = '/Session/ResultsReport';
